import React, { ReactElement } from 'react';
import ActionToolbarMenu from "./ActionToolbarMenu";
import {
  Component, Position,
  PuzzleDropDownButton
} from 'puzzle'
import * as _ from 'lodash';
import { SUBMISSION } from "../../MainGrid/Types";
import {
  disableActions,
  getUrlWithParams,
  hiddenActionPairsMap,
  prepareMassActions,
  SUBMISSION_STATUSES_MAP_SERVER_CORE_UI,
  taskSorter
} from "../../util/Util";
import ActionExecutorInstance from "../../SupplierView/TaskList/ActionExecutor/ActionExecutor";
import { TASK } from "../../SupplierView/TaskGrid/Types";
import { map } from "lodash";

type STATE = {
  actions: ACTION[],
  checkboxSelected: any[]
  selectedSubmission: any,
  decodedTasks: number[]
}

type PROPS = {
  userInfo: any,
  selectionLimit: number
}

export type WORKFLOW_CONFIGURATION = {
  gradingAndScoring: string
  hasCompletedFiles: boolean
  hasClaimedFiles: boolean
};

export type ACTION = {
  alternativeGroupName?: string
  endpoint: string | null
  groupName: string
  groupWeight: number
  requestMethod?: string
  selectStyle: number
  massTaskName?: string
  taskName: string
  taskId: number
  weight: number
  isDisabled?: boolean
}

class ActionToolbar extends Component<PROPS, STATE> {
  staticActions: ReactElement[] = [];

  //names of actions that are supposed to be displayed without action name
  noTextActions: String[] = ['mass_download'];

  /**
   * Opens File Assign Supplier dialog
   * @param task
   */
  assignFilesSupplier = (task: TASK) => {
    let {
      sourceLanguage,
      targetLanguage,
      projectId,
      submissionId,
      taskId,
      fileCount: filesCount
    } = task;

    this.dispatch('assignCrossoverDialog', '', {
      dialogData: {
        assignRequestParams: {
          submissionId,
          taskId
        },
        filesCount,
        projectId,
        sourceLanguage,
        submissionId,
        targetLanguage,
        taskId,
      }
    });
  }

  /**
   * Creates dom elements(Split Buttons) that represent one group of actions (manage,quotes etc...)
   */
  createToolbarItems() {
    const { actions } = this.state;
    let actionsList: ReactElement[] = [];

    if (actions) {
      const actionMap = taskSorter(actions);
      let action;
      for (let actionKey of actionMap) {
        if (actionKey.groupName !== 'hidden') {
          action = this.transformData(actionKey.elements, actionKey.groupName);
          actionsList.push((
            <PuzzleDropDownButton
              key={"actionGroup " + actionKey.groupName}
              themeColor={'primary'}
              popupSettings={{
                anchorAlign: {
                  horizontal: 'right',
                  vertical: 'bottom'
                },
                popupAlign: {
                  horizontal: 'right',
                  vertical: 'top'
                }
              }}
              icon='arrow-s'
              reverse
              onItemClick={this.handleItemClick.bind(this)}
              items={action}
              text={this.translate(actionKey.groupName + '.' + actionKey.groupName)}
            />
          ));
        }
      }
      actionsList = [...this.staticActions, ...actionsList];
    }
    return actionsList;
  }

  /**
   * Transforms data into a way which allows us to flag the disabled state of dropdown item
   * @param list
   * @param groupName
   */
  transformData = (list: any[], groupName: string) => {
    const { decodedTasks, selectedSubmission } = this.state;
    const { selectionLimit } = this.props;
    return list.reduce((newArray: any, item: ACTION) => {
      const { selectStyle, taskName, massTaskName } = item;
      let { checkboxSelected } = this.state;
      let disabled = this.isActionDisabled(item) || checkboxSelected?.length > selectionLimit;
      let translatedActionName = this.translate(groupName + '.' + _.replace(taskName, / /g, '_'));
      if (massTaskName && checkboxSelected?.length > 1) {
        translatedActionName = `${translatedActionName} (${checkboxSelected.length})`;
      }
      let hideAction = false;
      let matchingAction = hiddenActionPairsMap.get(item.taskName);
      if (matchingAction) {
        if (selectedSubmission?.length) {
          hideAction = disabled && decodedTasks.includes(matchingAction);
        } else {
          hideAction = _.findIndex(newArray, { 'text': translatedActionName }) !== -1;
        }
      }
      if (!hideAction) {
        newArray.push({
          disabled,
          massTaskName,
          taskName,
          text: translatedActionName,
          selectStyle
        })
      }
      return newArray;
    }, []);
  }

  /**
   * Dispatch action for download
   * @param submission
   * @param params
   */
  dispatchDownloadAction = (submission: any, params: any) => {
    let availableOrReserved = submission.taskStatus?.name === 'AVAILABLE' || submission.taskStatus?.name === 'RESERVED';
    let actionName;
    let confirmActionName;
    if (availableOrReserved && (params.downloadType !== 'references')) {
      actionName = 'previewWarningAndDownload';
      confirmActionName = 'downloadFiles';
    } else {
      actionName = 'downloadFiles';
    }
    this.dispatch(actionName, '', {
      submissionData: submission,
      params: params,
      confirmActionName
    });
  }

  /**
   * Action click handler(open proper dialog)
   * @param event
   */
  handleItemClick(event: any) {
    let { item } = event;
    const { checkboxSelected, selectedSubmission } = this.state;
    const { selectionLimit } = this.props;
    const { selectStyle } = item;

    let massSelected = checkboxSelected && checkboxSelected?.length > 1;
    if (selectStyle !== 0 && (_.isEmpty(selectedSubmission) || selectedSubmission.length > 1) && !massSelected) {
      this.dispatch('selectedSubmissionIsRequired', '', { taskName: item.taskName });

      //TODO saved code in case for multi selection
      // switch (item.taskName) {
      //   case 'preview translation':
      //     const submissionIds = selectedSubmission.map(this.mapSubmissionIds).join(',');
      //     this.dispatch(_.replace(item.taskName, / /g, '_'), '', { params: { submissionIds } });
      //     break;
      //   default:
      //     break;
      // }
    } else {
      const submission = selectedSubmission ? selectedSubmission[0] : 0;
      const isDisabled = this.isActionDisabled(item);
      let editor;
      if (!isDisabled) {
        let taskName = item.taskName;
        if (checkboxSelected && checkboxSelected.length > 1 && item.massTaskName) {
          taskName = item.massTaskName;
        } else {
          this.dispatch('checkboxSelectionClear');
        }
        switch (taskName) {
          case 'analyze submission':
          case 'assign submission vendor':
          case 'claim':
          case 'claim job phase':
          case 'delete submission system':
          case "manual edit submission":
          case 'manual clone submission':
          case 'quote request':
          case 'quote withdraw':
          case 'start submission':
          case 'quote review report':
          case 'quote review':
          case 'quote add edit po':
          case 'rest upload':
          case 'unclaim job phase':
          case 'job phase upload':
          case 'reserve job phase':
          case 'reopen submission':
          case 'job phase view offer':
            this.dispatch(_.replace(item.taskName, / /g, '_'), '', { submissionData: submission });
            break;
          case "manual edit completed submission":
            this.dispatch('manual_edit_submission', '', { submissionData: submission });
            break;
          case 'download submission source files':
            this.dispatch('source_files', '', {
              submissionId: submission.submissionId,
              submissionName: submission.submissionName
            });
            break;
          case 'download submission history':
            this.dispatch('downloadAuditLog', '', {
              submissionId: submission.submissionId,
              params: {
                submissionHistory: true
              }
            });
            break;
          case 'manual submission':
            this.dispatch('goToPath', '', { path: '/view/submission' });
            break;
          case 'preview translation':
            this.dispatch('preview_translation', '', {
              params: { submissionIds: submission.submissionId },
              submissionName: submission.submissionName
            });
            break;
          case 'cancel nui':
            if (SUBMISSION_STATUSES_MAP_SERVER_CORE_UI.ON_HOLD.includes(submission.submissionStatus.name)) {
              this.dispatch('cancelOnHoldSubmission', {
                pos: Position.end,
                persistent: ['submissionId']
              }, { submissionData: submission, submissionId: submission.submissionId });
            } else {
              this.dispatch(_.replace(item.taskName, / /g, '_'), '', { submissionData: submission });
            }
            break;
          case  'task download reference files':
            let paramsReferenceFiles = { downloadType: 'references' };
            this.dispatchDownloadAction(submission, paramsReferenceFiles);
            break;
          case  'task download source files':
            let paramsSourceFiles = { downloadType: 'sources' };
            this.dispatchDownloadAction(submission, paramsSourceFiles);
            break;
          case  'task download supplementary files':
            let paramsSupplementaryFiles = { downloadType: 'supplementary' };
            this.dispatch('downloadFiles', '', { submissionData: submission, params: paramsSupplementaryFiles });
            break;
          case  'task download glp':
            let paramsGLPFiles = { downloadType: 'WF5' };
            this.dispatchDownloadAction(submission, paramsGLPFiles);
            break;
          case  'task download all kits':
            let paramsLocalizationKit = { downloadType: 'localizationKit' };
            this.dispatchDownloadAction(submission, paramsLocalizationKit);
            break;
          case "open jobphase editor":
            editor = _.get(submission, 'availableEditors[0]');
            ActionExecutorInstance.executeOpenTask(submission, editor);
            break;
          case 'task complete jobPhase files':
            this.dispatch('completeConfirmationWarning', '', {
              submissionData: submission
            });
            break;
          case 'task return jobPhase files':
            this.dispatch('task_complete_jobPhase_files', '', {
              actionName: 'demote',
              executionModuleName: 'ActionExecutor',
              promoteFilesAction: 'completeActionWarnings',
              submissionData: submission,
              completeSupplierURL: `/jobPhases/${submission.taskId}/return`
            });
            break;
          case 'task preview jobphase':
            ActionExecutorInstance.previewTask(submission);
            break;
          //mass actions
          case 'mass claim job phase':
          case 'mass unclaim job phase':
          case 'mass start submission':
            if (checkboxSelected.length && checkboxSelected.length <= selectionLimit) {
              this.dispatch(_.replace(taskName, / /g, '_'), '', { selectedItems: checkboxSelected });
            }
            break;
          case "task assign jobPhase files":
            this.assignFilesSupplier(submission);
            break;
          case "copy URI":
            let urlToCopy = getUrlWithParams(submission.submissionId);
            this.dispatch(_.replace(item.taskName, / /g, '_'), '', { urlToCopy });
            break;
          default:
            break;
        }
      }
    }
  }

  /**
   * Check if action need to be disabled
   */
  isActionDisabled = (item: ACTION) => {
    const { checkboxSelected, decodedTasks, selectedSubmission } = this.state;
    let disabled = !_.isEmpty(selectedSubmission) && !decodedTasks.includes(item.taskName);
    if (checkboxSelected?.length > 1) {
      disabled = !item.massTaskName;
    }
    return disabled;
  }

  /**
   * Extract submissionId from submission
   */
  mapSubmissionIds = (submission: SUBMISSION) => submission.submissionId;

  /**
   * Sets the current state toolbar component on mainGridSelection(Dispatcher action)
   *
   */
  menageState(submissions: SUBMISSION[]) {
    submissions = submissions.map((item: SUBMISSION) => {
      if (!item.availableTasks) {
        item.availableTasks = 0;
      }
      return item;
    });

    let decodedTasks = submissions.length ? disableActions(submissions) : [];
    decodedTasks.push('copy URI');
    this.setState({
      ...this.state,
      selectedSubmission: submissions,
      decodedTasks: decodedTasks
    });
  }

  /**
   * Updates action array with new actions, preserving existing one
   *
   * @param newActions
   */
  modifyActionTasksWithNewActions = (newActions: ACTION[]) => {
    const { actions } = this.state;
    newActions = _.unionBy(actions, newActions, 'taskName');
    return newActions;
  };

  /**
   * Set checkbox selected items
   */
  setCheckboxSelected = (items: any[]) => {
    this.setState({
      checkboxSelected: items
    });
  }

  /**
   * Prepare and set data that's saved in Dispatcher's appOperationData when MainGrid initialized
   * MassActions need to be parsed and prepared for toolbar
   */
  prepareActionsData = (data: ACTION[]) => {
    const { actions = [] } = this.state;
    if (actions.length) {
      data = this.modifyActionTasksWithNewActions([...data]);
    }

    data = prepareMassActions(data);
    this.setState({
      actions: data,
      decodedTasks: []
    });
  };

  /**
   * Prepare params for mass start request
   * @param selectedItems
   */
  prepareMassStartParams = (selectedItems: SUBMISSION[]) => {
    return {
      submissionIds: map(selectedItems, 'submissionId'),
    };
  }

  renderBody() {
    return (<ActionToolbarMenu items={this.createToolbarItems()} decodedTasks={this.state.decodedTasks} />)
  }
}

export default ActionToolbar;
